import config from '../config';
import keyMirror from 'key-mirror';

export const paths = {
  Fundraising: '/fundraising',
  Personal: '/personal',
  Name: '/personal/name',
  Email: '/personal/email',
  Address: '/personal/address',
  AddressResults: '/personal/address-results',
  DateOfBirth: '/personal/date-of-birth',
  PhoneNumber: '/personal/phone-number',
  Password: '/security/password',
  Security: '/security',
  SecurityMfa: '/security/mfa',
  SecurityAccessCode: '/security/access-code',
  DonationHistory: '/donation-history',
  DonationSummary: '/donation-summary/:id',
  PaymentMethods: '/payment-methods',
  Notifications: '/notifications',
  MonthlyDonations: '/monthly-donations',
  Apps: '/apps',

  Redirect: '/redirect',
  Retry: '/retry',
  Index: '/',
};

export const consentStatementTypes = {
  directMarketingEmail: 'DirectMarketingEmail',
};

export const ActionTypes = keyMirror({
  REFRESH_ACCESS_TOKEN: null,
  REFRESH_ACCESS_TOKEN_SUCCESS: null,
  REFRESH_ACCESS_TOKEN_FAILURE: null,

  CLEAR_UPDATE_PASSWORD: null,

  FETCH_USER: null,
  FETCH_USER_SUCCESS: null,
  FETCH_USER_FAILURE: null,
  UPDATE_USER: null,

  FETCH_USER_ADDRESS: null,
  FETCH_USER_ADDRESS_SUCCESS: null,
  FETCH_USER_ADDRESS_FAILURE: null,
  UPDATE_USER_ADDRESS: null,
  FETCH_FIND_ADDRESSES: null,
  FETCH_FIND_ADDRESSES_SUCCESS: null,
  FETCH_FIND_ADDRESSES_FAILURE: null,
  RESET_FIND_ADDRESSES: null,

  UPDATE_LOGIN_STATUS: null,

  FETCH_NOTIFICATIONS: null,
  FETCH_NOTIFICATIONS_SUCCESS: null,
  FETCH_NOTIFICATIONS_FAILURE: null,
  UPDATE_NOTIFICATIONS: null,

  FETCH_RECURRING_PAYMENTS: null,
  FETCH_RECURRING_PAYMENTS_SUCCESS: null,
  FETCH_RECURRING_PAYMENTS_FAILURE: null,
  CANCEL_RECURRING_PAYMENTS: null,
  CANCEL_RECURRING_PAYMENTS_SUCCESS: null,
  CANCEL_RECURRING_PAYMENTS_FAILURE: null,

  FETCH_DIRECTDEBIT_PAYMENTS: null,
  FETCH_DIRECTDEBIT_PAYMENTS_SUCCESS: null,
  FETCH_DIRECTDEBIT_PAYMENTS_FAILURE: null,
  CANCEL_DIRECTDEBIT_PAYMENTS: null,
  CANCEL_DIRECTDEBIT_PAYMENTS_SUCCESS: null,
  CANCEL_DIRECTDEBIT_PAYMENTS_FAILURE: null,

  UPDATE_PASSWORD_FAILURE: null,

  KOALA_TRACK_PAGE_VIEW: null,
  KOALA_TRACK_LINK_CLICK: null,
  KOALA_TRACK_EVENT_EXTENDED: null,
  KOALA_TRACK_EVENT: null,

  UPDATE_APP_STATUS_FETCH_ERROR: null,
  UPDATE_APP_STATUS_POST_ERROR: null,
  RESET_APP_ERRORS: null,
  PAGE_NOT_FOUND: null,
  UPDATE_COUNTRY_CODE: null,
  UPDATE_STATE_CODE: null,

  FETCH_USER_NOTIFICATIONS: null,
  FETCH_USER_NOTIFICATIONS_SUCCESS: null,
  FETCH_USER_NOTIFICATIONS_FAILURE: null,

  FETCH_DONATION_HISTORY: null,
  FETCH_DONATION_HISTORY_SUCCESS: null,
  FETCH_DONATION_HISTORY_FAILURE: null,

  FETCH_DONATION_SUMMARY: null,
  FETCH_DONATION_SUMMARY_SUCCESS: null,
  FETCH_DONATION_SUMMARY_FAILURE: null,

  FETCH_PAYMENT_METHODS: null,
  FETCH_PAYMENT_METHODS_SUCCESS: null,
  FETCH_PAYMENT_METHODS_FAILURE: null,

  DELETE_CARD: null,
  DELETE_CARD_SUCCESS: null,
  DELETE_CARD_FAILURE: null,

  FETCH_CONSENT_STATEMENTS: null,
  FETCH_CONSENT_STATEMENTS_SUCCESS: null,
  FETCH_CONSENT_STATEMENTS_FAILURE: null,

  UPDATE_USER_CONSENT: null,
  UPDATE_USER_NOTIFICATIONS: null,

  CLOSE_CONSENT_MODAL: null,

  UNLINK_FACEBOOK: null,
  UNLINK_FACEBOOK_SUCCESS: null,
  UNLINK_FACEBOOK_FAILURE: null,

  MFA_ENABLED: null,
  SAVE_MFA_ACCESS_CODE: null,
  HIDE_SUCCESS_TOAST: null,
});

export const IAM = {
  baseUrl: config.iam.baseUrl,
};

export const recurringPayments = {
  baseUrl: config.recurringPayments.baseUrl,
};

export const charity = {
  baseUrl: config.charity.baseUrl,
};

export const profile = {
  baseUrl: config.profile.baseUrl,
  userConsent: 'user-status/consent',
  urlSuffix: 'profile',
};

export const image = {
  baseUrl: config.image.baseUrl,
  defaultImage:
    'data:image/png;base64,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',
  defaultAvatar:
    'data:image/svg+xml;base64,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',
  noAccessCodeAvatar:
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjYwIiBmaWxsPSIjQkNFMUZGIi8+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSIxMjAiPgo8Y2lyY2xlIGN4PSI2MCIgY3k9IjYwIiByPSI2MCIgZmlsbD0iI0JDRTFGRiIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPGNpcmNsZSBjeD0iNjAiIGN5PSIxMTciIHI9IjQ1IiBmaWxsPSIjMTZDQzVFIi8+CjxyZWN0IHg9IjQ4IiB5PSI4MyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjQxIiByeD0iNCIgZmlsbD0iIzI1MkIzMyIvPgo8Y2lyY2xlIGN4PSI2OCIgY3k9Ijg3IiByPSIyIiBmaWxsPSIjQzRDNEM0Ii8+CjxjaXJjbGUgY3g9IjUyIiBjeT0iMTEyIiByPSIxMiIgZmlsbD0iI0NEQTI3OCIvPgo8L2c+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTA2LjE0MSA1NS4zNzExQzEwMS43NjEgNTguMDg2IDk1Ljk3MjggNTkuMDAzNSA5MS4wMTIzIDU4LjAxM0M4Ni4wNDQ2IDU3LjAxNDkgNzkuMTM3NyA1My4zMTUgODAuNjQ4IDQ3LjYyODhDODEuMzg4NyA0NC45NDExIDg0LjY0NSA0Mi40MzM1IDg3LjczMDggNDMuMjEyOUM5Mi4yMDMxIDQ0LjM4ODEgOTMuMDA4MyA0OS4wMjU3IDk2LjA1MzMgNTEuODI4NEM5OC41MjI3IDU0LjA0NDEgMTAyLjU4MiA1Ni4xNzIzIDEwNi4xNDEgNTUuMzcxMVoiIGZpbGw9IiM1QzQzMkQiLz4KPGNpcmNsZSBjeD0iNjAiIGN5PSIzOCIgcj0iMzAiIGZpbGw9IiNDREEyNzgiLz4KPHBhdGggZD0iTTYwIDYwQzY2LjYyNzQgNjAgNzIgNTQuNjI3NCA3MiA0OEg0OEM0OCA1NC42Mjc0IDUzLjM3MjYgNjAgNjAgNjBaIiBmaWxsPSJ3aGl0ZSIvPgo8bWFzayBpZD0ibWFzazEiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjMwIiB5PSI4IiB3aWR0aD0iNjAiIGhlaWdodD0iNjAiPgo8Y2lyY2xlIGN4PSI2MCIgY3k9IjM4IiByPSIzMCIgZmlsbD0iI0NEQTI3OCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazEpIj4KPGNpcmNsZSBjeD0iODAiIGN5PSI0IiByPSIzMCIgZmlsbD0iIzVDNDQyRCIvPgo8Y2lyY2xlIGN4PSIyMSIgY3k9IjQiIHI9IjMwIiBmaWxsPSIjNUM0NDJEIi8+CjwvZz4KPC9zdmc+Cg==',
};

export const preferencesService = {
  baseUrl: config.preferencesService.baseUrl,
};

export const forms = {
  Password: 'passwordForm',
  Name: 'nameAndTitleForm',
  Email: 'emailAddressForm',
  Address: 'addressForm',
  DateOfBirth: 'dateOfBirthForm',
  PhoneNumber: 'phoneNumberForm',
  Notifications: 'notificationsForm',
  DonationSummary: 'donationSummary',
  DonationHistory: 'donationhistory',
  PaymentMethods: 'paymentMethods',
  AccesCode: 'accessCodeForm',
};

export const cookieNames = {
  authCookieName: config.authCookieName,
};

export const APIerrorMessages = {
  wrongCurrentPassword: 'Current Passwords do not match.',
  emailAlreadyInUse: 'The requested email address is already in use.',
};

export const apiCallConfig = {
  allowedNumberOfReties: 2,
  timeoutInMs: 4000,
};

export const features = config.features || {};

export const collectionLocationId = config.collectionLocationId;

export const donationTypes = {
  charityFRP: 'CharityFRP',
  globalGivingProject: 'GlobalGivingProject',
  campaignDirect: 'CampaignDirect',
  crowdfunding: 'Crowdfunding',
  charityDirect: 'CharityDirect',
};
